/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![TextLockIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABRElEQVR4nNVVMU7DQBA8CkRLG4mnQBWEXPh29xp2IQWdOxJS5ht0gWfACyAB8ZF0kXgBoLXPEsR3yRnLEow01ax3Tntza2P+A4B4YpFXFeW6fQOUV0uyDGmIfAIkn4DyYJEfgeQjp4vj5ObOjQbawKKsQ7olmameZdmBsqwlmaWfHs5PqxPyc6D5stRCDNSHDYgn/qN5U4s090wysMh3fkQ3vRgAykKLc+KzzgZbZ0oVv192awO9mN0GvDLG7O2qtyRPO8eTIw99xhemD4CTcSxBRVHsI14ddjMgmZcGTsZNjW9VQ+TL3xugTxDysI0WREqCIIWxF5ySIEhgUno2dtDLpqaPrnO66h1kie+b5jKNpSsZ9Q4CkGlUC6QrGTqa6A5qm6AQLMq7NnFudBTQ1l4bdDDgN/1V1nvnh6aR7mt9/Dl8Ad+gWQmMBTV9AAAAAElFTkSuQmCC)
 */
export const TextLockIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M16 4h.5v-.5a2.5 2.5 0 0 1 5 0V4h.5a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-6a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1Zm4-.5V4h-2v-.5a1 1 0 1 1 2 0Z"
        clipRule="evenodd"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M12.5 8c.28 0 .5.22.5.5V9c0 .1 0 .2.02.31.03.34-.21.69-.56.69H9.85l-.67 4h4.97l.28-1.68c.06-.34.44-.52.77-.43a3 3 0 0 0 .8.11c.27 0 .47.24.43.5l-.25 1.5H20a1 1 0 1 1 0 2h-4.15l-.86 5.16a1 1 0 0 1-1.98-.32l.8-4.84H8.86l-.86 5.16A1 1 0 0 1 6 20.84L6.82 16H3a1 1 0 1 1 0-2h4.15l.67-4H4a1 1 0 1 1 0-2h4.15l.86-5.16a1 1 0 1 1 1.98.32L10.19 8h2.31Z"
        className={colorClass}
      />
    </svg>
  );
};
